import ctx from '../../plugins/axios';

// eslint-disable-next-line import/no-anonymous-default-export
export default async (UUID) => {
  return await ctx.get(`/specialty_list/comments/${UUID}`);
};
